import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/auth-redirect"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: { title: "首页总览", icon: "syzl", affix: true },
      },
    ],
  },
  // {
  //   path: "/documentation",
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/documentation/index"),
  //       name: "Documentation",
  //       meta: { title: "documentation", icon: "documentation", affix: true },
  //     },
  //   ],
  // },
  // {
  //   path: "/guide",
  //   component: Layout,
  //   redirect: "/guide/index",
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/guide/index"),
  //       name: "Guide",
  //       meta: { title: "guide", icon: "guide", noCache: true },
  //     },
  //   ],
  // },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/profile/index"),
        name: "Profile",
        meta: { title: "profile", icon: "user", noCache: true },
      },
    ],
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: "/enterprise",
  //   component: Layout,
  //   redirect: "/enterprise/page",
  //   alwaysShow: true,
  //   name: "Enterprise",
  //   meta: {
  //     title: "机构主页",
  //     icon: "tools",
  //   },
  //   children: [
  //     {
  //       path: "page",
  //       component: () => import("@/views/enterprise/page"),
  //       name: "PageEnterprise",
  //       meta: {
  //         title: "机构档案",
  //       },
  //     },
  //     {
  //       path: "attendance",
  //       component: () => import("@/views/attendance/index"),
  //       name: "PageAttendance",
  //       meta: {
  //         title: "考勤记录",
  //       },
  //     },
  //     {
  //       path: "inventory",
  //       component: () => import("@/views/inventory/index"),
  //       name: "PageInventory",
  //       meta: {
  //         title: "库存管理",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/PageEnterprise",
    component: Layout,
    redirect: "/PageEnterprise",
    children: [
      {
        path: "index",
        component: () => import("@/views/enterprise/page"),
        name: "CodeSearch",
        meta: { title: "机构档案", icon: "jgda" },
      },
    ],
  },
  {
    path: "/PageAttendance",
    component: Layout,
    redirect: "/PageAttendance",
    children: [
      {
        path: "index",
        component: () => import("@/views/attendance/index"),
        name: "PageAttendance",
        meta: { title: "考勤记录", icon: "kqjl" },
      },
    ],
  },
  {
    path: "/PageInventory",
    component: Layout,
    redirect: "/PageInventory",
    children: [
      {
        path: "index",
        component: () => import("@/views/inventory/index"),
        name: "PageInventory",
        meta: { title: "库存管理", icon: "kcgl" },
      },
    ],
  },
  {
    path: "/codeSearch",
    component: Layout,
    redirect: "/codeSearch",
    children: [
      {
        path: "index",
        component: () => import("@/views/codeSearch/index"),
        name: "CodeSearch",
        meta: { title: "追溯码查询", icon: "zsmcx" },
      },
    ],
  },
];

// 连锁总部路由
export const chainRoutes = [
  {
    path: "/ChainStore",
    component: Layout,
    redirect: "/ChainStore",
    children: [
      {
        path: "index",
        component: () => import("@/views/store/index"),
        name: "ChainStore",
        meta: { title: "门店列表", icon: "mdlb" },
      },
    ],
  },
  {
    path: "/ChainStoreAttendance",
    component: Layout,
    redirect: "/ChainStoreAttendance",
    children: [
      {
        path: "index",
        component: () => import("@/views/storeAttendance/index"),
        name: "ChainStoreAttendance",
        meta: { title: "门店考勤", icon: "mdkq" },
      },
    ],
  },
  {
    path: "/Remote",
    component: Layout,
    redirect: "/Remote",
    children: [
      {
        path: "index",
        component: () => import("@/views/remote/index"),
        name: "Remote",
        meta: { title: "远程审方", icon: "ycsf" },
      },
    ],
  },
  {
    path: "/PrescriptionRecord",
    component: Layout,
    redirect: "/PrescriptionRecord",
    children: [
      {
        path: "index",
        component: () => import("@/views/prescriptionRecord/index"),
        name: "PrescriptionRecord",
        meta: { title: "审方记录", icon: "sfjl" },
      },
    ],
  },
  // {
  //   path: "/chain",
  //   component: Layout,
  //   redirect: "/chain/store",
  //   alwaysShow: true,
  //   name: "chain",
  //   meta: {
  //     title: "连锁门店",
  //     icon: "tools",
  //   },
  //   children: [
  //     {
  //       path: "store",
  //       component: () => import("@/views/store/index"),
  //       name: "ChainStore",
  //       meta: {
  //         title: "门店列表",
  //       },
  //     },
  //     {
  //       path: "storeAttendance",
  //       component: () => import("@/views/storeAttendance/index"),
  //       name: "ChainStoreAttendance",
  //       meta: {
  //         title: "考勤记录",
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/prescriptionChain",
  //   component: Layout,
  //   redirect: "/prescriptionChain/store",
  //   alwaysShow: true,
  //   name: "prescriptionChain",
  //   meta: {
  //     title: "处方管理",
  //     icon: "tools",
  //   },
  //   children: [
  //     {
  //       path: "remote",
  //       component: () => import("@/views/remote/index"),
  //       name: "Remote",
  //       meta: {
  //         title: "远程审方",
  //       },
  //     },
  //     {
  //       path: "prescriptionRecord",
  //       component: () => import("@/views/prescriptionRecord/index"),
  //       name: "PrescriptionRecord",
  //       meta: {
  //         title: "审方记录",
  //       },
  //     },
  //   ],
  // },
];

// 连锁门店路由
export const storeRoutes = [
  {
    path: "/Prescription",
    component: Layout,
    redirect: "/Prescription",
    children: [
      {
        path: "index",
        component: () => import("@/views/prescription/index"),
        name: "Prescription",
        meta: { title: "处方管理", icon: "cfgl" },
      },
    ],
  },
  // {
  //   path: "/store",
  //   component: Layout,
  //   redirect: "/store/prescription",
  //   alwaysShow: true,
  //   name: "store",
  //   meta: {
  //     title: "处方管理",
  //     icon: "tools",
  //   },
  //   children: [
  //     {
  //       path: "prescription",
  //       component: () => import("@/views/prescription/index"),
  //       name: "Prescription",
  //       meta: {
  //         title: "处方管理",
  //       },
  //     },
  //   ],
  // },
];

// 常用工具
export const oftenToolRoutes = [
  {
    path: "/MyOrder",
    component: Layout,
    redirect: "/MyOrder",
    children: [
      {
        path: "index",
        component: () => import("@/views/myOrder/index"),
        name: "MyOrder",
        meta: { title: "订单管理", icon: "ddgl" },
      },
    ],
  },
  // {
  //   path: "/oftenTool",
  //   component: Layout,
  //   redirect: "/oftenTool/myOrder",
  //   alwaysShow: true,
  //   name: "OftenTool",
  //   meta: {
  //     title: "常用工具",
  //     icon: "tools",
  //   },
  //   children: [
  //     {
  //       path: "myOrder",
  //       component: () => import("@/views/myOrder/index"),
  //       name: "MyOrder",
  //       meta: {
  //         title: "我的订单",
  //       },
  //     },
  //   ],
  // },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
